import { FileUploadDialogComponent } from '@/components/file-upload-dialog/file-upload-dialog.component';
import { FilterPropertyListData } from '@/components/filters-property-list/filters-property-list.component';
import { PropertyAddSimpleDialogComponent } from '@/components/property-add-simple-dialog/property-add-simple-dialog.component';
import { PropertyAttributesAddDialogComponent } from '@/components/property-attributes-add-dialog/property-attributes-add-dialog.component';
import { IRealProperty } from '@/components/property-list/property-list.component';
import { CertificationHelper } from '@/helpers/certification.helper';
import { MatHelper } from '@/helpers/mat-helper.helper';
import { PropertyHelper } from '@/helpers/property.helper';
import { UserHelper } from '@/helpers/user.helper';
import { AppConfigService } from '@/services/app-config.service';
import { AppService } from '@/services/app.service';
import { DictionaryCacheService } from '@/services/dictionary-cache.service';
import { FileUploadType } from '@/services/file-upload.service';
import { NavService } from '@/services/nav.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {
  Attribute,
  AttributeGroup,
  PhotosService,
  PropertiesService,
  PropertyChildrenTypeFilter,
  PropertyType,
  RealProperty,
  RealPropertySummary
} from '@eemo/api-client';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription, combineLatest, startWith } from 'rxjs';
import { coreEnvironment } from 'src/environments/core/core-environment';
import { PropertyListComponent } from '../../../components/property-list/property-list.component';
import { FiltersPropertyListComponent } from '../../../components/filters-property-list/filters-property-list.component';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { PropertyProfilComponent } from '../../../components/property-profil/property-profil.component';
import { NgIf } from '@angular/common';

export class AttributeValue {
  name: string;
  value: string;
}

export interface RealPropertyDetail extends RealProperty {
  floor?: string;
  num?: string;
}

@Component({
    selector: 'app-condo-management',
    templateUrl: './condo-management.component.html',
    styleUrls: ['./condo-management.component.scss'],
    animations: MatHelper.getTableAnimations(),
    standalone: true,
    imports: [NgIf, PropertyProfilComponent, MatButtonModule, RouterLink, MatIconModule, FiltersPropertyListComponent, PropertyListComponent]
})
export class CondoManagementComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren(MatCheckbox) propsCheckboxes: QueryList<MatCheckbox>;

  propertiesChangeObs$: Observable<[void, void]>;
  propertiesChange$: Subscription = new Subscription();

  propId: string;
  prop: RealProperty;
  allProps: RealPropertySummary[] = [];
  UserHelper = UserHelper;

  mainPhoto: SafeUrl;

  titleClass = 'title-normal';

  isLoadingResults = true;
  accessDenied = false;

  dataSource: MatTableDataSource<RealPropertyDetail>;
  displayChildren = false;
  childrenType: PropertyChildrenTypeFilter = PropertyChildrenTypeFilter.BOUND;
  displayFullColumns = false;
  tableClass = 'light';

  expandedElement: RealPropertySummary | null;

  availablePropTypes: PropertyType[];

  globalCountPropTypes: { [key: string]: number };

  selectedProps: IRealProperty[] = [];
  filterData: FilterPropertyListData;
  reload = 0;

  filterSelectedTypes = [];
  filterAttributesValue: { [key: string]: AttributeValue } = {};
  filterAttributesCode = [];

  filterDisplayAttributeGroups: AttributeGroup[];
  filterDisplayAttributes: { [key: string]: Attribute[] } = {};
  filterDisplayAttributeValues: { [key: string]: AttributeValue[] } = {};

  newlist: IRealProperty[] = [];
  globalAvailablePropTypes: PropertyType[] = [];

  lightColumns = coreEnvironment.tables.property.condo.lightColumns;
  fullColumns = coreEnvironment.tables.property.condo.fullColumns;

  constructor(
    private route: ActivatedRoute,
    private navService: NavService,
    private propertyService: PropertiesService,
    private photoService: PhotosService,
    public propHelper: PropertyHelper,
    public userHelper: UserHelper,
    private dialog: MatDialog,
    public certificationHelper: CertificationHelper,
    public dictCacheService: DictionaryCacheService,
    private domSanitizer: DomSanitizer,
    private deviceService: DeviceDetectorService,
    private appConfig: AppConfigService,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.propertiesChange$ = combineLatest([
      this.appService.wasCreatedProperty$,
      this.appService.wasDeletedProperty$.pipe(startWith(null))
    ]).subscribe(([created, deleted]) => {
      this.loadAllPropertiesData();
    });

    this.route.paramMap.subscribe((params) => {
      const uid = params.get('uid');
      this.propertyService.getRealProperty(uid).subscribe(
        (result) => {
          this.propId = result.uid;
          this.prop = result;
          this.appConfig.selectedProp = this.prop;
          this.loadAllPropertiesData();
          this.mainPhoto = this.propHelper.getEmptyMainPhotoImage();
          this.photoService.getMainPhotoImage(this.prop.uid, '640x360', this.prop.mainPhotoTs).subscribe((photo) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              this.mainPhoto = this.domSanitizer.bypassSecurityTrustUrl(reader.result.toString());
            };
            reader.readAsDataURL(photo);
          });
        },
        (err: HttpErrorResponse) => {
          if (err.status === 403) {
            this.accessDenied = true;
          }
        }
      );
    });
  }

  ngOnDestroy(): void {
    this.propertiesChange$.unsubscribe();
  }

  loadAllPropertiesData() {
    this.propertyService.getRealPropertyLocationSummaryList(this.propId).subscribe((data) => {
      this.allProps = data;
      const globalAvailablePropTypes = [];
      this.globalCountPropTypes = {};
      data.forEach((element) => {
        // global count
        if (globalAvailablePropTypes.includes(element.type)) {
          this.globalCountPropTypes[element.type] += 1;
        } else {
          globalAvailablePropTypes.push(element.type);
          this.globalCountPropTypes[element.type] = 1;
        }
      });

      globalAvailablePropTypes.sort(PropertyHelper.sortPropertyTypeList);
      this.globalAvailablePropTypes = globalAvailablePropTypes;
    });
  }

  updateTitleClass() {
    if (this.prop.name.length > 30) {
      this.titleClass = 'title-small';
    } else {
      this.titleClass = 'title-normal';
    }
  }

  addChild(parent: RealProperty) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(PropertyAddSimpleDialogComponent, {
        data: { parent, withAddressSearch: false }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.loadAllPropertiesData();
          this.reload = ++this.reload;
        }
      });
    }
  }

  addDocs() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(FileUploadDialogComponent, {
        data: { uploadType: FileUploadType.DOC, props: this.selectedProps }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.reload = ++this.reload;
        }
      });
    }
  }

  addPhotos() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(FileUploadDialogComponent, {
        data: { uploadType: FileUploadType.PHOTO, props: this.selectedProps }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.reload = ++this.reload;
        }
      });
    }
  }

  updateAttributes() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(PropertyAttributesAddDialogComponent, {
        data: { props: this.selectedProps }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.reload = ++this.reload;
        }
      });
    }
  }
}
